module.exports = __webpack_public_path__ + "static/media/Mac Miller - Weekend (feat. Miguel) [Lyrics].48c238b2.mp3";